/**
 * Language utility functions for URL-based language detection and management
 */

/**
 * Gets the language from URL query parameters
 * @returns The language code from URL or null if not found
 */
export const getLanguageFromURL = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("lang");
};

/**
 * Sets the language in the URL query parameters
 * @param languageCode - The language code to set
 * @param replace - Whether to replace the current history entry (default: true)
 */
export const setLanguageInURL = (
  languageCode: string,
  replace: boolean = true
): void => {
  const url = new URL(window.location.href);
  url.searchParams.set("lang", languageCode);

  if (replace) {
    window.history.replaceState({}, "", url.toString());
  } else {
    window.history.pushState({}, "", url.toString());
  }
};

/**
 * Removes the language parameter from the URL
 * @param replace - Whether to replace the current history entry (default: true)
 */
export const removeLanguageFromURL = (replace: boolean = true): void => {
  const url = new URL(window.location.href);
  url.searchParams.delete("lang");

  if (replace) {
    window.history.replaceState({}, "", url.toString());
  } else {
    window.history.pushState({}, "", url.toString());
  }
};

/**
 * Validates if a language code is supported
 * @param languageCode - The language code to validate
 * @returns True if the language is supported
 */
export const isLanguageSupported = (languageCode: string): boolean => {
  const supportedLanguages = ["en",
  "de",
  "es",
  "ar",
  "nl",
  "pt",
  "ru",
  "uk",
  "hi",
  "ur",
  "yo",
  "id",
  "it",
  "ja",
  "sw",
  "pl",
  "vi",
  "ro",
  "zh-hant",
  "zh",
  "hr",
  "fa",
  "ko",
  "sv",
  "hu",
  "sq", 
  "fr"];
  return supportedLanguages.includes(languageCode.toLowerCase());
};
